<template>
  <v-card
    height="100%"
    width="100%"
    color="transparent"
    flat>
    <!-- <v-img
      class="white--text"
      position="top"
      src="https://picsum.photos/1024/640?random"
      gradient="to top right, rgba(19,84,122,1), rgba(128,208,199,.5)"
    >-->
    <div class="d-flex justify-space-between">
      <div class="survey-category-border"></div>
      <div class="d-flex survey-category">
        <span
          style="font-size: 32px"
          class="mr-3"
          >{{ questionCategory === 'Master' ? 'Life' : questionCategory === 'Life' ? 'Family' : questionCategory }}</span
        >
        <v-icon
          large
          right
          color="secondary"
          >{{ icon[questionCategory] }}</v-icon
        >
      </div>
    </div>
    <open-ended-survey
      v-if="questionType === 'openEnded'"
      :q-number="questionNumber"
      :q-id="questionId"
      :q-message="questionMessage"
      :q-title="questionTitle"
      :email-type="emailType"
      :q-predicate="questionPredicate"
      :max-text="maxText"
      :q-category="questionCategory"
      @nextSlide="next" />
    <ordering-survey
      v-if="questionType === 'ordering'"
      :q-category="questionCategory"
      :q-id="questionId"
      :q-number="questionNumber"
      :q-message="questionMessage"
      :q-title="questionTitle"
      :items="answerList"
      @nextSlide="next" />
    <likert-survey
      v-if="questionType === 'likertScale'"
      :q-number="questionNumber"
      :q-id="questionId"
      :q-message="questionMessage"
      :q-title="questionTitle"
      :answer-list="answerList"
      :sub-message="questionSub"
      :sub-category="questionSubCategory"
      :q-category="questionCategory"
      @nextSlide="next" />
    <multi-survey
      v-if="questionType.includes('multi')"
      :q-type="questionType"
      :q-number="questionNumber"
      :q-id="questionId"
      :q-message="questionMessage"
      :q-title="questionTitle"
      :q-list="questionList"
      :sub-category="questionSubCategory"
      :q-category="questionCategory"
      :target="target"
      :q-option="questionOption"
      @nextSlide="next" />
    <action-survey
      v-if="questionType.includes('action')"
      :q-type="questionType"
      :q-number="questionNumber"
      :q-id="questionId"
      :q-message="questionMessage"
      :q-title="questionTitle"
      :q-list="questionList"
      :sub-category="questionSubCategory"
      :q-category="questionCategory"
      :target="target"
      :q-option="questionOption"
      :q-placeholder="questionPlaceholder"
      @nextSlide="next" />
    <career-history-survey
      v-if="questionType.includes('history')"
      :q-type="questionType"
      :q-number="questionNumber"
      :q-id="questionId"
      :q-message="questionMessage"
      :q-title="questionTitle"
      :q-list="questionList"
      :sub-category="questionSubCategory"
      :q-category="questionCategory"
      :target="target"
      :q-option="questionOption"
      @nextSlide="next" />
    <select-survey
      v-if="questionType.includes('select')"
      :q-type="questionType"
      :q-number="questionNumber"
      :q-id="questionId"
      :q-message="questionMessage"
      :q-title="questionTitle"
      :q-list="questionList"
      :sub-category="questionSubCategory"
      :q-category="questionCategory"
      :target="target"
      :q-option="questionOption"
      @nextSlide="next" />
    <title-survey
      v-if="questionType === 'title'"
      :q-number="questionNumber"
      :q-id="questionId"
      :q-message="questionMessage"
      :q-title="questionTitle"
      :q-list="questionList"
      :body="body"
      :sub-category="questionSubCategory"
      :q-category="questionCategory"
      @nextSlide="next" />

    <!-- </v-img> -->
  </v-card>
</template>

<script>
import TitleSurvey from '@/components/TitleSurvey'
import MultiSurvey from '@/components/MultiSurvey'
import OpenEndedSurvey from '@/components/OpenEndedSurvey'
import OrderingSurvey from '@/components/OrderingSurveyAlt'
import LikertSurvey from '@/components/LikertScaleSurvey'
import CareerHistorySurvey from '@/components/CareerHistorySurvey'
import ActionSurvey from '@/components/ActionSurvey'
import SelectSurvey from '@/components/SelectSurvey'
export default {
  components: {
    TitleSurvey,
    OpenEndedSurvey,
    OrderingSurvey,
    LikertSurvey,
    MultiSurvey,
    CareerHistorySurvey,
    SelectSurvey,
    ActionSurvey,
  },
  props: {
    uuid: { type: String, default: '' },
    questionOption: { type: Object, default: () => {} },
    questionList: { type: Array, default: () => [] },
    questionPlaceholder: { type: String, default: '' },
    body: {
      type: String,
      default: '',
    },
    target: {
      type: String,
      default: '',
    },
    questionId: {
      type: String,
      default: '',
    },
    questionSub: {
      type: String,
      default: '',
    },
    questionUid: {
      type: String,
      default: '',
    },
    questionCategory: {
      type: String,
      default: 'Master',
    },
    questionSubCategory: {
      type: String,
      default: '',
    },
    questionNumber: {
      type: String,
      default: 'questionNumber',
    },
    questionMessage: {
      type: String,
      default: '정당의 목적이나 활동이 민주적 기본질서에 위배될 때에는 정부는 헌법재판소에 그 해산을 제소할 수 있고, 정당은 헌법재판소의 심판에 의하여 해산된다.',
    },
    questionTitle: {
      type: String,
      default: '정당의 목적',
    },
    questionType: {
      type: String,
      default: 'openEnded',
    },
    questionPredicate: {
      type: String,
      default: '',
    },
    emailType: {
      type: Boolean,
      default: false,
    },
    maxText: {
      type: Number,
      default: 10,
    },
    answerList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      icon: {
        Finance: 'mdi-finance',
        Master: 'mdi-heart-multiple',
        Career: 'mdi-briefcase',
        Life: 'mdi-home',
        Action: 'mdi-map-marker-star-outline',
      },
      valid: false,
      items: [
        { title: '돈', subTitle: '경제적 안정' },
        { title: '집', subTitle: '가족 간 배려, 소통' },
        { title: '일', subTitle: '전문성/직업의 연속성' },
        { title: '벗', subTitle: '외롭지 않는 삶. 네트웍' },
        { title: '낙', subTitle: '즐거운 꺼리들' },
        { title: '건강', subTitle: '몸과 마음의 건강' },
      ],
    }
  },
  methods: {
    next() {
      this.$emit('next')
    },
  },
}
</script>

<style lang="scss">
.survey-category {
  font-weight: 900 !important;
  color: #70cae9;
  font-size: 24px;
}
.survey-category-border {
  margin: 0px 10px;
  border-bottom: 1px solid #70cae9;
  flex-basis: 80%;
  transform: translateY(-10px);
}
</style>
